import { Router } from '@angular/router';
import { CurrentUser } from '../auth/current-user';
import { AuthService } from '../auth/auth.service';
import { Settings } from '@common/core/config/settings.service';
import * as i0 from "@angular/core";
import * as i1 from "../auth/current-user";
import * as i2 from "@angular/router";
import * as i3 from "../auth/auth.service";
import * as i4 from "../core/config/settings.service";
export class CheckPermissionsGuard {
    constructor(currentUser, router, auth, settings) {
        this.currentUser = currentUser;
        this.router = router;
        this.auth = auth;
        this.settings = settings;
    }
    canActivate(route, state) {
        return this.runAuthCheck(route, state);
    }
    canActivateChild(route, state) {
        return this.runAuthCheck(route, state);
    }
    runAuthCheck(route, state) {
        if (this.settings.get('billing.force_subscription') && !this.currentUser.isAdmin() && !this.currentUser.isSubscribed() && !route.data.allowIfSubscriptionForced) {
            this.router.navigate(['/billing/upgrade']);
        }
        else {
            return this.checkPermissions(route, state);
        }
    }
    getActiveRoute(route) {
        while (route.firstChild)
            route = route.firstChild;
        return route;
    }
    checkPermissions(route, state) {
        let hasPermission = true;
        if (route.data.permissions) {
            hasPermission = this.currentUser.hasPermissions(route.data.permissions);
        }
        // user can access this route, bail
        if (hasPermission)
            return true;
        // redirect to login page, if user is not logged in
        if (!this.currentUser.isLoggedIn()) {
            this.currentUser.redirectUri = state.url;
            this.router.navigate(['login']);
        }
        else {
            const uri = this.shouldRedirectToUpgrade(route.data.permissions) ? '/billing/upgrade' : this.auth.getRedirectUri();
            this.router.navigate([uri]);
        }
        return hasPermission;
    }
    shouldRedirectToUpgrade(permissions) {
        const goingToAdmin = permissions.length && permissions[0].includes('admin');
        return !goingToAdmin && this.settings.get('billing.enable');
    }
}
CheckPermissionsGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CheckPermissionsGuard_Factory() { return new CheckPermissionsGuard(i0.ɵɵinject(i1.CurrentUser), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.AuthService), i0.ɵɵinject(i4.Settings)); }, token: CheckPermissionsGuard, providedIn: "root" });
